import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import {
  AlertTriangle,
  ShieldCheck,
  AlertCircle,
  Shield
} from "lucide-react";

const UserRiskAssessment = () => {
  const { data: users } = useQuery({
    queryKey: ['users-risk'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*');
      if (error) throw error;
      return data;
    }
  });

  const getRiskLevel = (user: any) => {
    // Simplified risk assessment logic
    if (!user.phone_number) return 'high';
    if (!user.country) return 'medium';
    return 'low';
  };

  const getRiskIcon = (risk: string) => {
    switch (risk) {
      case 'high':
        return <AlertTriangle className="h-6 w-6 text-red-500" />;
      case 'medium':
        return <AlertCircle className="h-6 w-6 text-yellow-500" />;
      case 'low':
        return <ShieldCheck className="h-6 w-6 text-green-500" />;
      default:
        return <Shield className="h-6 w-6 text-gray-500" />;
    }
  };

  return (
    <div className="space-y-4">
      {users?.map((user) => {
        const riskLevel = getRiskLevel(user);
        return (
          <Card key={user.id} className="p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                {getRiskIcon(riskLevel)}
                <div>
                  <h3 className="text-lg font-semibold">{user.first_name} {user.last_name}</h3>
                  <p className="text-sm text-muted-foreground">Risk Level: {riskLevel.toUpperCase()}</p>
                </div>
              </div>
              <div className="text-sm">
                <p>Location: {user.country || 'Unknown'}</p>
                <p>Phone Verified: {user.phone_number ? 'Yes' : 'No'}</p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default UserRiskAssessment;